import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useWorkspaceDeveloperRequestStatsQuery.ts
var r = (r, i = !0) => t({
	queryKey: e.requestStats(r),
	queryFn: () => n.requestStats(r ? { environment: r } : void 0),
	enabled: i
});
//#endregion
export { r as useWorkspaceDeveloperRequestStatsQuery };
